import { lazyPanes } from '@/lib/lazy-panes'

/** A functional group's panes, off the /orgs list chunk; the `$groupId` loader preloads them. */
export const orgGroupDetail = lazyPanes(() => import('./org-group-detail-panes'))
